import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = {
    visible: Boolean
  }

  toggle() {
    this.visibleValue = !this.visibleValue
  }

  visibleValueChanged() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden", !this.visibleValue)
    }
  }
}
